import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import RoleInfoPanel from "./RoleInfoPanel";
import RoleInfoTabMenu from "./RoleInfoTabMenu";
import useLoading from "../../../../../../../shared/components/loading/useLoading";
import useAxios from "../../../../../../../hooks/useAxios";
import { catchFunction } from "../../../../../../../shared/lib/utils";
import { SECURITY_CENTRE_ROLES } from "../../../../../../../shared/lib/routesResolver";
import {
  API_SECURITY_CENTRE_PERMISSIONS,
  API_SECURITY_CENTRE_ROLES_BY_ID,
  API_SECURITY_CENTRE_USERS_BY_ROLE,
} from "../../../../../../../shared/lib/apiEndpointsResolver";
import BreadcrumbPanel from "../../../../../../../shared/components/breadcrumb/BreadcrumbPanel";

const RoleDetail = () => {
  const { id } = useParams();
  const { setLoading } = useLoading();
  const axios = useAxios();
  const [role, setRole] = useState();
  const [users, setUsers] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const breadcrumbItems = [
    { title: "Roles", link: SECURITY_CENTRE_ROLES },
    { title: role?.name },
  ];

  const findRole = () => {
    setLoading(true);
    axios
      .get(API_SECURITY_CENTRE_ROLES_BY_ID(id))
      .then((response) => setRole(response.data))
      .catch(catchFunction)
      .finally(() => setLoading(false));
  };

  const findUsersByRole = () => {
    axios
      .get(API_SECURITY_CENTRE_USERS_BY_ROLE(id))
      .then((response) => setUsers(response.data))
      .catch(catchFunction);
  };

  const findRolePermissions = () => {
    axios
      .get(`${API_SECURITY_CENTRE_PERMISSIONS}?role=${id}`)
      .then((response) => setPermissions(response.data))
      .catch(catchFunction)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    findRole();
    findUsersByRole();
    findRolePermissions();
  }, [id]);

  return (
    <>
      <div className="px-4 pb-4 sm:px-6">
        <BreadcrumbPanel items={breadcrumbItems} />
      </div>
      <div className="flex flex-col gap-y-4">
        <div className="flex flex-row justify-between gap-x-4 px-4">
          <RoleInfoPanel role={role} />
          <div></div>
        </div>
        <RoleInfoTabMenu users={users} permissions={permissions} />
      </div>
    </>
  );
};

export default RoleDetail;
